import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenService } from '../../services/authen.service';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { MyDataAdaptor } from '../../helpers/grid.adaptor';
import { DropDownList } from "../../models/dropdownlist.model";
@Component({
    selector: '',
    templateUrl: 'principal-user.html',
})
export class PrincipalUserComponent implements OnInit {
    items: any = null;
    checked: boolean = true;
    data: DataManager;
    pageSettings: PageSettingsModel;
    fields: Object = { text: 'label', value: 'value' };
    principalDDL: Array<any> = [];
    principalID: number = 0;
    keywordSearch: string = "";
    constructor(private http: HttpService, private helper: HelperService, private auth: AuthenService) {

        this.pageSettings = { pageSize: 20 };
    }

    ngOnInit() {
        //this.getPrincipalDDL();
        this.search();
    }
    onActionFailure(e: Error): void {
        this.helper.alert(e.message);
    }
  
    search() {
        this.data = new DataManager({ url: `${this.http.baseUrl}api/PrincipalUser/GetPage?principal=${this.principalID}&keyword=${this.keywordSearch}`, adaptor: new MyDataAdaptor(this.helper), crossDomain: true });
    }
    getPrincipalDDL() {
        this.http.get('api/PrincipalUser/GetAllPrincipalDDL?prnEx=' + this.auth.PrincipalEx, res => {
            this.principalDDL = res;
            var allOption = new DropDownList();
            allOption.label = "All";
            allOption.value =0;
            this.principalDDL.push(allOption);
        }, null);
    }
    onChangePrincipal(e) {
        this.principalID = e.value;
    }
    renderAccessRightColumn(value: number) {
        var accessRights: Array <any> =[
            { label: "Read", value: 1 },
            { label: "Write", value: 2 },

        ];
        var result = accessRights.filter(x => x.value == value)[0];
        return result.label;
    }
}
